import axios from 'axios';
import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi'; // Eye icons
import { useNavigate, useSearchParams } from 'react-router-dom';
import carImage from '../../images/Technician-login/bglogo.png';
import Loading from '../../loading';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // "success" or "error"
  const [showPassword, setShowPassword] = useState(false); // For new password visibility
  const [showPasswords, setShowPasswords] = useState(false); // For confirm password visibility
  const [passwordStrength, setPasswordStrength] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const API_URL = process.env.REACT_APP_API_URL;

  // Function to evaluate password strength
  const evaluatePasswordStrength = (password) => {
    let strength = '';
    if (password.length < 6) {
      strength = 'Weak';
    } else if (password.length >= 6 && password.length < 12) {
      strength = 'Medium';
    } else if (password.length >= 12 && /[A-Z]/.test(password) && /[0-9]/.test(password) && /[^A-Za-z0-9]/.test(password)) {
      strength = 'Strong';
    } else {
      strength = 'Medium';
    }
    setPasswordStrength(strength);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match');
      setMessageType('error');
      return;
    }

    // Check password strength
    const passwordPattern =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    if (!passwordPattern.test(newPassword)) {
      alert(
        "Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character."
      );
      return;
    }    

    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/auth/confirm-reset-password`, { token, newPassword });
      setMessage(res.data.msg);
      setMessageType('success');

      // Redirect to login after 2 seconds
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMessage(err.response?.data?.msg || 'Something went wrong');
      setMessageType('error');
    } finally {
      setLoading(false); // Stop loading after the try/catch
    }
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen bg-banner text-white font-clash">
      {/* Reset Password Form */}
      <div className="relative z-10 bg-transparent p-8 max-w-lg w-full shadow-lg rounded-2xl border border-[#F0FFC5] flex flex-col justify-center items-center sm:items-stretch">
        <h2 className="text-2xl font-semibold mb-10 text-[#F0FFC5]">Reset Password</h2>
        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-4 relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                evaluatePasswordStrength(e.target.value);  // Update strength on password change
              }}
              required
              className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
            />
            <div
              className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </div>
          </div>
          <div className="mb-4 relative">
            <input
              type={showPasswords ? 'text' : 'password'}
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="border rounded-3xl w-full py-3 px-3 bg-transparent border-[#F0FFC5] focus:outline-none focus:ring-2 focus:ring-[#F0FFC5] transition text-[#F0FFC5]"
            />
            <div
              className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setShowPasswords((prev) => !prev)}
            >
              {showPasswords ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </div>
          </div>
          {/* {passwordStrength && (
            <div className={`mb-4 text-sm ${passwordStrength === 'Strong' ? 'text-green-500' : passwordStrength === 'Medium' ? 'text-yellow-500' : 'text-red-500'}`}>
              Password strength: {passwordStrength}
            </div>
          )} */}
          {loading ? (
            <div>
              <Loading />
            </div>
            ) : (
          <button
            type="submit"
            className="bg-transparent border border-[#F0FFC5] text-[#F0FFC5] font-bold mt-6 py-2 px-6 rounded-3xl w-full sm:w-auto 
            hover:bg-[#F0FFC5] hover:text-black active:bg-[#D0FF93] active:text-black transition duration-300"
            disabled={loading}                    
          >
          Reset Password
          </button>
          )}
        </form>
        {message && (
          <p className={`mt-4 text-sm ${messageType === 'success' ? 'text-green-500' : 'text-red-500'}`}>
            {message}
          </p>
        )}
      </div>

      {/* Car Image at the Bottom */}
      <img
        src={carImage}
        alt="car image"
        className="absolute lg:block hidden bottom-0 w-full h-auto max-h-[400px] object-contain z-0"
      />
    </div>
  );
};

export default ResetPasswordPage;
